import APICall from "../utils/APICall";

export default class FXTransactionServices {
  // foreign transaction list
  static listFxTransactions = async (
    page,
    pageLimit,
    search,
    from,
    to,
    sourceCurrency,
    destinationCurrency,
    status
  ) => {
    let url = `/api/ForeignTransaction/admin/list-foreign-transactions?page=${page}&pageLimit=${pageLimit}`;

    if (search) url += `&search=${search}`;
    if (from) url += `&from=${from}`;
    if (to) url += `&to=${to}`;
    if (sourceCurrency) url += `&sourceCurrency=${sourceCurrency}`;
    if (destinationCurrency)
      url += `&destinationCurrency=${destinationCurrency}`;
    if (status) url += `&status=${status}`;

    return await APICall(url, "GET");
  };
  //foreign transaction rate list

  static viewFxTransactionRate = async (applicationParameter) => {
    let url = "/api/ForeignTransaction/admin/list-foreign-transaction-rates";
    if (applicationParameter) {
      url += `?applicationParameter=${applicationParameter}`;
    }
    return await APICall(url, "GET");
  };
  

  // foreign transaction update rate
  static updateFxTransactionRate = async (payload) => {
    return await APICall(
      "/api/ForeignTransaction/admin/update-foreign-transaction-rate",
      "POST",
      payload
    );
  };

  // foreign transaction export
  static exportFxTransactionRate = async (
  search,
  sourceCurrency,
  destinationCurrency,
  status,
  from,
  to
) => {
  const params = new URLSearchParams();

  if (from) params.append("from", from);
  if (to) params.append("to", to);
  if (search) params.append("search", search);
  if (sourceCurrency) params.append("sourceCurrency", sourceCurrency);
  if (destinationCurrency) params.append("destinationCurrency", destinationCurrency);
  if (status) params.append("status", status);

  const url = `/api/ForeignTransaction/admin/export-foreign-transactions?${params.toString()}`;
  return await APICall(url, "GET");
};


  // toggle foreign transaction availability
  static toggleFxTransactionAvailability = async (payload) => {
    return await APICall(
      "/api/ForeignTransaction/admin/toggle-foreign-transaction-settings",
      "PATCH",
      payload
    );
  };
}
